import { call, put } from 'redux-saga/effects';
import { getSettings } from "../../../lib/utilities/index";

const fetchSettingsData = async () => {
    try {
        let settings = await getSettings();
        return {
            settings
        }
    } catch (e) {
        console.log(e);
        throw e;
    }
}

function* fetchSettingsDataSaga(action) {
    try {
        const {
            settings
        } = yield call(fetchSettingsData);
        yield put({
            type: 'FETCH_SETTINGS_DATA_SUCCESSFUL',
            settings
        })
    } catch (e) {
        yield put({ type: 'FETCH_SETTINGS_DATA_FAILED', error: e.message });
    }
}

export default fetchSettingsDataSaga;